import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import compose from '../../utils/helper-functions/compose';
import { getCurrentPage } from '../../utils/helper-functions/get-current-page';

export const withCurrentPage = (Wrapped) => {
  const Hoc = (props) => {
    const {
      location: { pathname: locationPathname },
    } = props;
    const [currentPage, setCurrentPage] = useState(
      () => getCurrentPage(locationPathname) ?? 'unknown',
    );

    useEffect(() => {
      const currentPageName = getCurrentPage(locationPathname) ?? 'unknown';
      setCurrentPage(currentPageName);
    }, [locationPathname]);

    return <Wrapped {...props} currentPage={currentPage} />;
  };
  return compose(withRouter)(Hoc);
};
